import axiosInstance from "../utils/axiosInstance";

const FALLBACK_ERROR = "متأسفم، مشکلی پیش آمد.";

export const useChat = ({ endpoint = "/chatbot/" } = {}) => {
  const sendMessage = async (userInput, history = []) => {
    if (!userInput.trim()) return null;

    try {
      const { data } = await axiosInstance.post(endpoint, {
        message: userInput,
        history,
      });

      if (data.reply) {
        return data.reply;
      }

      const choice = data.choices?.[0];
      const candidate = data.candidates?.[0];
      const text =
        choice?.message?.content ??
        candidate?.content?.parts?.[0]?.text ??
        candidate?.text;

      return text || FALLBACK_ERROR;
    } catch {
      return FALLBACK_ERROR;
    }
  };

  return { sendMessage };
};
